import type {
  CreverseGuestAdmissionResponse,
  CreverseGuestResponse,
  CreverseGuestSyncHistoryResponse,
  CreverseGuestSyncRequest,
  CreverseGuestSyncResponse,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import {
  adaptCreverseGuestAdmissions,
  adaptGuests,
  adaptGuestSyncLatest,
  adaptGuestSyncResult,
} from './adapters'
import type { CreverseGuestAdmission, Guest, GuestSyncLatest, GuestSyncResult } from './schemas'

export type GuestSyncRequest = CreverseGuestSyncRequest

// 세션이 주제인 요청이라 teacher 의 크레버스 SSO 오류 처리가 실패한 요청의 URL 을 이 값과 대조한다.
export const CREVERSE_GUEST_SYNC_PATH = '/creverse/guests/sync'

// 이 컨트롤러는 CommonResponse 봉투 없이 본문을 바로 낸다.
// 로그인 학원에 동기화된 비재원생 전건. 이름 오름차순이고 페이지네이션이 없다.
export const getGuests = async (meta?: RequestMeta): Promise<Guest[]> => {
  const body = await httpClient().get<CreverseGuestResponse[]>('/creverse/guests', { meta })
  return adaptGuests(body) ?? []
}

// 배정 모달용 시험 회차 목록. 비재원생 한 명이 회차마다 한 행씩 나온다.
export const getCreverseGuestAdmissions = async (
  meta?: RequestMeta,
): Promise<CreverseGuestAdmission[]> => {
  const body = await httpClient().get<CreverseGuestAdmissionResponse[]>(
    '/creverse/guests/admissions',
    { meta },
  )
  return adaptCreverseGuestAdmissions(body) ?? []
}

export const syncGuests = async (
  body: GuestSyncRequest,
  meta?: RequestMeta,
): Promise<GuestSyncResult> => {
  const result = await httpClient().post<CreverseGuestSyncResponse>(
    CREVERSE_GUEST_SYNC_PATH,
    body,
    {
      meta,
    },
  )
  return adaptGuestSyncResult(result)
}

export const getLatestGuestSync = async (meta?: RequestMeta): Promise<GuestSyncLatest> => {
  const body = await httpClient().get<CreverseGuestSyncHistoryResponse>(
    '/creverse/guests/sync/latest',
    { meta },
  )
  return adaptGuestSyncLatest(body)
}
